import React, { FC } from 'react';
import translate from '@translate';
import BodyTopBlock from 'src/components/BodyTopBlock';

interface TopBlockProps {
    disableEdit: boolean;
    handleSave: () => void;
}

const TopBlock: FC<TopBlockProps> = (props) => {
    return (
        <BodyTopBlock
            actions={[
                {
                    label: translate('geisPackingTypeDetail.action.save'),
                    onClick: props.handleSave,
                    hidden: props.disableEdit,
                    'data-testid': 'geis-packing-type-save',
                },
            ]}
        />
    );
};

export default TopBlock;
